import React, { useContext } from 'react';

import { AccordionNavigationMenu } from 'components/modules/navigation/components';
import { StyleRulesSettingsTabContext } from 'components/pages/StyleRulesPage/components/SettingsTab/SettingsTab.context';

import './StyleRulesSettingsLeftNavigationMenu.scss';

const propTypes = {};

const defaultProps = {};

export default function StyleRulesSettingsLeftNavigationMenu() {
  const { getStyleRuleConfigurationsFolderItems, onSelectFolder, selectedFolder } = useContext(
    StyleRulesSettingsTabContext,
  );

  function onSelectNavigationItem({ id }) {
    onSelectFolder(id.split('.'));
  }

  const navigationMenuItems = getStyleRuleConfigurationsFolderItems();

  return (
    <div className="style-rules-settings-left-navigation-menu">
      <AccordionNavigationMenu
        items={navigationMenuItems}
        onSelectItem={onSelectNavigationItem}
        openItemIds={selectedFolder ? [selectedFolder.join('.')] : []}
        highlightedItemIds={selectedFolder ? [selectedFolder.join('.')] : []}
      />
    </div>
  );
}

StyleRulesSettingsLeftNavigationMenu.propTypes = propTypes;
StyleRulesSettingsLeftNavigationMenu.defaultProps = defaultProps;
